import axios from 'axios';
import { polusBaseUrl, uwBaseUrl, POST } from '../../../utils/axios-interceptor';
import { getTimeStamp } from '../../../utils/dateUtils';

// BSA report generation is a single blocking call that runs the full
// fetch->compute->render->upload pipeline server-side (can take minutes for
// large orgs) — disable the default axios timeout so the client doesn't abort
// the request before the backend responds.
const BSA_REPORT_GENERATE_TIMEOUT_MS = 900000;

export function fetchBankStatementDataService() {
    return axios({
        baseURL: polusBaseUrl,
        url: API_ENDPOINTS.FETCH_BANK_STMT_DATA,
        method: POST,
        data: {
            requestId: getTimeStamp(),
            // "endDate" : "2024-01-31",
            csv: false,
        },
    });
}

// Single blocking call: UW invokes the report-generation lambda synchronously
// and only responds once the file is generated and uploaded — no polling.
export function bsaGenerateService(investeeOrgId: string) {
    return axios({
        baseURL: uwBaseUrl,
        url: API_ENDPOINTS.BSA_REPORT_GENERATE,
        method: POST,
        data: { investeeOrgId },
        timeout: BSA_REPORT_GENERATE_TIMEOUT_MS,
    });
}

const API_ENDPOINTS = {
    FETCH_BANK_STMT_DATA: '/data/bankStatementData',
    BSA_REPORT_GENERATE: '/bank/bsa-report/generate',
};
